import React from 'react';
import { formatTalleres } from '../../../utils';
import styles from '../../../styles/shared/Checklist.module.css';
import { formatDate, formatTime } from '../../../utils/date';

const RequestChecklist = ({ mostrarCheckList, setMostrarCheckList, solicitud, procesarPedido }) => {

    if (!mostrarCheckList || !solicitud) {
        return null;
    }

     return (
        <div className={styles.backdrop} onClick={() => setMostrarCheckList(false)}>
            <div className={styles.checklist} onClick={(e) => e.stopPropagation()}>
                <h1>Checklist</h1>
               
                    <div className={styles.container}>
                        <p>Taller: {formatTalleres(solicitud.taller)}</p>
                        <p>Fecha de retiro: {formatDate(solicitud.fecha_creacion)}</p>
                        <p>Hora de retiro: {formatTime(solicitud.fecha_creacion)}</p>
                        <p>Fecha de devolucion: {formatDate(solicitud.fecha_resolucion)}</p>
                        <p>Hora de devolucion: {formatTime(solicitud.fecha_resolucion)}</p>
                        <p>Ítems: {solicitud.carrito.items.length}</p>
                        <p>Descripción: {solicitud.descripcion}</p>
                        <div className={styles.button}>
                            <button onClick={() => setMostrarCheckList(false)}>Cerrar</button>
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default RequestChecklist;
